<template>
  <div
    class="map-modal-part"
    :class="{
      'if-left-fold-part': ifLeftFold,
      reduce: !isFold,
    }"
    v-dialogDrags="redactScene"
    v-resize="DomResize"
    :style="`
    --t:${partStyle.t != undefined ? partStyle.t : 'auto'};
    --b:${partStyle.b != undefined ? partStyle.b : 'auto'};
    --l:${partStyle.l != undefined ? partStyle.l : 'auto'};
    --r:${partStyle.r != undefined ? partStyle.r : 'auto'};
    --w:${partStyle.w != undefined ? partStyle.w : 'auto'};
    --h: ${
      isFold ? (partStyle.h != undefined ? partStyle.h : 'auto') : '65px'
    } ;
    --bg:${partStyle.bg != undefined ? partStyle.bg : 'auto'};
    --ac:${partStyle.ac != undefined ? partStyle.ac : 'auto'};`"
  >
    <div class="map-modal-part-operation">
      <i
        class="el-icon-edit"
        @click="openEdit"
        v-if="construction"
        style="margin-right: 15px"
      ></i>
      <i
        @click="fold()"
        :class="isFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
      ></i>
      <!-- el-icon-arrow-up -->
    </div>
    <template v-if="isFold">
      <div class="modal-part-header title">
        <h1>{{ title }}</h1>
      </div>
      <el-scrollbar>
        <div class="modal-part-body" v-html="contentHtml"></div>
      </el-scrollbar>
    </template>

    <div class="modal-part-header" v-else>
      <h1>{{ title }}</h1>
    </div>
  </div>
</template>
<script>
export default {
  name: "map-modal-part",
  props: {
    title: String,
    id: String,
    contentHtml: String,
    partStyle: Object,
    ifLeftFold: Boolean,
    construction: Boolean, //施工模拟
    redactScene: Boolean,
  },
  data() {
    return {
      isFold: true,
    };
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {
    //一个对象，键是需要观察的表达式，值是对应回调函数。
    //值也可以是方法名，或者包含选项的对象。
    //Vue 实例将会在实例化时调用 watch()，遍历 watch 对象的每一个 property。
  },
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    this.$emit("stretchModal");
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
  },

  methods: {
    fold() {
      this.isFold = !this.isFold;
      this.$emit("stretchModal");
    },
    openEdit() {
      this.$emit("openEdit");
    },
    DomResize(data) {
      if (this.isFold) {
        let { width, height } = data;
        this.$eventBus.$emit("changeStyle", {
          width,
          height,
        });
      }
    },
  },

  beforeUpdate() {
    //数据更新时调用，发生在虚拟 DOM 打补丁之前。这里适合在更新之前访问现有的 DOM，比如手动移除已添加的事件监听器。
    //该钩子在服务器端渲染期间不被调用，因为只有初次渲染会在服务端进行。
  },
  updated() {
    //由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    //当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
    //然而在大多数情况下，你应该避免在此期间更改状态。如果要相应状态改变，通常最好使用计算属性或 watcher 取而代之。
  },
  activated() {
    //被 keep-alive 缓存的组件激活时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  deactivated() {
    //被 keep-alive 缓存的组件停用时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  beforeUnmount() {
    //实例销毁之前调用。在这一步，实例仍然完全可用。
    //该钩子在服务器端渲染期间不被调用。
  },
  unmounted() {
    //实例销毁后调用。该钩子被调用后，对应 Vue 实例的所有指令都被解绑，所有的事件监听器被移除，所有的子实例也都被销毁。
    //该钩子在服务器端渲染期间不被调用。
  },
  errorCaptured() {
    //当捕获一个来自子孙组件的错误时被调用。
    //此钩子会收到三个参数：错误对象、发生错误的组件实例以及一个包含错误来源信息的字符串。
    //此钩子可以返回 false 以阻止该错误继续向上传播。
  },
  directives: {
    resize: {
      // 指令的名称
      bind(el, binding) {
        // el为绑定的元素，binding为绑定给指令的对象
        let width = "",
          height = "";
        function isReize() {
          const style = document.defaultView.getComputedStyle(el);
          if (width !== style.width || height !== style.height) {
            binding.value({ width: style.width, height: style.height }); // 关键(这传入的是函数,所以执行此函数)
          }
          width = style.width;
          height = style.height;
        }
        el.__vueSetInterval__ = setInterval(isReize, 300);
      },
      unbind(el) {
        clearInterval(el.__vueSetInterval__);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.map-modal-part {
  position: absolute;
  // top: var(--t);
  // left: var(--l);
  // bottom: var(--b);
  // right: var(--r);
  width: var(--w);
  height: var(--h);
  background-color: var(--bg);
  border: 1px solid var(--ac);
  padding: 20px 15px;
  overflow: hidden;
  z-index: 9;
  min-width: 300px;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  // transition: all 0.5s;
  h1 {
    color: var(--ac);
    margin: 0 0 10px 0;
    font-weight: bold;
  }
  .modal-part-body {
    color: #fff;
    overflow: hidden;
    margin-bottom: 20px;
    /deep/p {
      margin: 0;
    }
  }
  // transition: opacity 0.5s;
  // opacity: 0.4;
  // &:hover {
  //   opacity: 1;
  // }
  min-width: 300px;
  min-height: 120px;
}
.map-modal-part.reduce {
  width: auto !important;
  height: 65px !important;
  padding-right: 65px;
  padding: 5px 40px 5px 10px;
  justify-content: center;
  align-items: center;
  display: flex;
  left: auto !important;
  top: auto !important;
  bottom: 35px !important;
  right: 50px !important;
  transform: inherit !important;
  .map-modal-part-operation {
    position: absolute;
    z-index: 99999;
    color: #ccc;
    font-size: 18px;
    cursor: pointer;
    right: 15px;
  }
  h1 {
    margin: 0;
  }
  min-height: auto;
  min-width: auto;
}
.l-t {
  top: 100px !important;
  left: 275px !important;
  right: auto !important;
  bottom: auto !important;
}
.l-b {
  bottom: 30px !important;
  left: 275px !important;
  top: auto !important;
  right: auto !important;
}
.if-left-fold-part.l-t {
  top: 100px !important;
  left: 2% !important;
  right: auto !important;
  bottom: auto !important;
}
.if-left-fold-part.l-b {
  bottom: 30px !important;
  left: 2% !important;
  right: auto !important;
  top: auto !important;
}
.r-t {
  top: 100px !important;
  right: 85px !important;
  left: auto !important;
  bottom: auto !important;
}
.r-b {
  bottom: 30px !important;
  right: 85px !important;
  top: auto !important;
  left: auto !important;
}
.middle {
  left: 50%;
  top: 50%;
  bottom: auto !important;
  right: auto !important;
}
.map-modal-part-operation {
  position: absolute;
  right: 30px;
  z-index: 99999;
  color: #ccc;
  font-size: 18px;
  cursor: pointer;
  i:hover {
    color: #fff;
  }
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
}
</style>
